/* assets/article-album.js
 *
 * For blog posts tagged "album" (the content wrapper gets a
 * data-article-album attribute from main-article.liquid):
 *
 *  1. Finds runs of consecutive photos in the post and turns each run into
 *     a thumbnail grid. Text between photos stays where it is, so a post
 *     can have several separate mini-albums.
 *  2. Clicking a thumbnail opens a lightbox with previous/next, a counter,
 *     keyboard support (Esc, left/right arrows, Tab is kept inside the
 *     viewer), and swipe on touch screens.
 *
 * Without JavaScript, each thumbnail is a plain link to the large photo.
 */
(function () {
  'use strict';

  var content = document.querySelector('[data-article-album]');
  if (!content) return;

  var FULL_WIDTH = 2000;
  var THUMB_WIDTHS = [360, 600, 900];

  /* ---------- Image URL helpers ---------- */

  function isShopifyCdn(url) {
    return (
      url.hostname.indexOf('cdn.shopify.com') !== -1 ||
      url.pathname.indexOf('/cdn/shop/') !== -1
    );
  }

  // Returns the same image at a given width (Shopify CDN images only).
  function resized(src, width) {
    try {
      var url = new URL(src, window.location.href);
      if (!isShopifyCdn(url)) return src;
      // Strip old-style size suffixes like photo_1024x1024.jpg
      url.pathname = url.pathname.replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-zA-Z0-9]+$)/,
        ''
      );
      url.searchParams.delete('height');
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function canResize(src) {
    try {
      return isShopifyCdn(new URL(src, window.location.href));
    } catch (e) {
      return false;
    }
  }

  /* ---------- Find runs of consecutive photos ---------- */

  function isBlank(el) {
    if (el.tagName === 'BR') return true;
    if (/^(HR|IFRAME|VIDEO|SVG|TABLE|IMG)$/.test(el.tagName)) return false;
    if (el.querySelector('img, iframe, video, svg')) return false;
    return el.textContent.replace(/\s+/g, '') === '';
  }

  // True for an <img>, or a <p>/<div>/<figure>/<span> that holds only images.
  // Photos inside links, or with captions, are left alone.
  function imageOnly(el) {
    if (el.tagName === 'IMG') return true;
    if (!/^(P|DIV|FIGURE|SPAN)$/.test(el.tagName)) return false;
    if (!el.querySelector('img')) return false;
    if (el.querySelector('a, iframe, video, table, ul, ol, blockquote, h1, h2, h3, h4, h5, h6')) return false;
    return el.textContent.replace(/\s+/g, '') === '';
  }

  var runs = [];
  var run = [];
  Array.prototype.slice.call(content.children).forEach(function (el) {
    if (imageOnly(el) || (run.length && isBlank(el))) {
      run.push(el);
    } else {
      if (run.length) runs.push(run);
      run = [];
    }
  });
  if (run.length) runs.push(run);

  /* ---------- Build the thumbnail grids ---------- */

  var items = []; // { full, alt }
  var links = [];

  runs.forEach(function (elements) {
    var imgs = [];
    elements.forEach(function (el) {
      if (el.tagName === 'IMG') {
        imgs.push(el);
      } else {
        Array.prototype.forEach.call(el.querySelectorAll('img'), function (img) {
          imgs.push(img);
        });
      }
    });

    if (!imgs.length) return;
    // Safety: if any photo has no src (e.g. lazy-loading placeholders),
    // leave this whole run alone rather than risk dropping a photo.
    var allHaveSrc = imgs.every(function (img) {
      return !!img.getAttribute('src');
    });
    if (!allHaveSrc) return;

    var grid = document.createElement('div');
    grid.className = 'article-album__grid';
    elements[0].parentNode.insertBefore(grid, elements[0]);

    imgs.forEach(function (img) {
      var src = img.getAttribute('src');
      var alt = img.getAttribute('alt') || '';

      var link = document.createElement('a');
      link.className = 'article-album__thumb';
      link.href = resized(src, FULL_WIDTH);

      var thumb = document.createElement('img');
      thumb.src = resized(src, THUMB_WIDTHS[1]);
      if (canResize(src)) {
        thumb.srcset = THUMB_WIDTHS.map(function (w) {
          return resized(src, w) + ' ' + w + 'w';
        }).join(', ');
        thumb.sizes = '(min-width: 750px) 230px, 45vw';
      }
      thumb.alt = alt;
      thumb.loading = 'lazy';
      thumb.decoding = 'async';

      link.appendChild(thumb);
      grid.appendChild(link);

      items.push({ full: link.href, alt: alt });
      links.push(link);
    });

    elements.forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  });

  // Diagnostic marker: lets you confirm in the browser's Elements panel that
  // this script ran (the value is how many photos it turned into thumbnails).
  content.setAttribute('data-article-album-ready', String(items.length));

  if (!items.length) return;

  // Every thumbnail link needs an accessible name, including photos
  // without alt text.
  links.forEach(function (link, i) {
    var alt = items[i].alt;
    link.setAttribute(
      'aria-label',
      alt
        ? 'View larger photo: ' + alt
        : 'View larger photo ' + (i + 1) + ' of ' + items.length
    );
    link.setAttribute('aria-haspopup', 'dialog');
  });

  /* ---------- Lightbox ---------- */

  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/></svg>';
  var ICON_PREV =
    '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
  var ICON_NEXT =
    '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

  var lightbox = document.createElement('div');
  lightbox.className = 'article-album-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Photo viewer');
  lightbox.hidden = true;
  lightbox.innerHTML =
    '<div class="article-album-lightbox__backdrop"></div>' +
    '<button type="button" class="article-album-lightbox__btn article-album-lightbox__close" aria-label="Close photo viewer">' + ICON_CLOSE + '</button>' +
    '<button type="button" class="article-album-lightbox__btn article-album-lightbox__prev" aria-label="Previous photo">' + ICON_PREV + '</button>' +
    '<button type="button" class="article-album-lightbox__btn article-album-lightbox__next" aria-label="Next photo">' + ICON_NEXT + '</button>' +
    '<figure class="article-album-lightbox__figure">' +
    '<img class="article-album-lightbox__img" alt="">' +
    '<figcaption class="article-album-lightbox__caption" aria-live="polite"></figcaption>' +
    '</figure>';
  document.body.appendChild(lightbox);

  var backdrop = lightbox.querySelector('.article-album-lightbox__backdrop');
  var closeBtn = lightbox.querySelector('.article-album-lightbox__close');
  var prevBtn = lightbox.querySelector('.article-album-lightbox__prev');
  var nextBtn = lightbox.querySelector('.article-album-lightbox__next');
  var bigImg = lightbox.querySelector('.article-album-lightbox__img');
  var caption = lightbox.querySelector('.article-album-lightbox__caption');

  var current = 0;
  var lastFocus = null;

  if (items.length < 2) {
    prevBtn.hidden = true;
    nextBtn.hidden = true;
  }

  function preload(i) {
    var n = items.length;
    var img = new Image();
    img.src = items[(i + n) % n].full;
  }

  function show(i) {
    var n = items.length;
    current = (i + n) % n;
    var item = items[current];

    bigImg.classList.add('is-loading');
    bigImg.onload = bigImg.onerror = function () {
      bigImg.classList.remove('is-loading');
    };
    bigImg.src = item.full;
    bigImg.alt = item.alt;
    caption.textContent = current + 1 + ' / ' + n + (item.alt ? ' - ' + item.alt : '');

    if (n > 1) {
      preload(current + 1);
      preload(current - 1);
    }
  }

  function next() {
    if (items.length > 1) show(current + 1);
  }

  function prev() {
    if (items.length > 1) show(current - 1);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
    } else if (e.key === 'ArrowRight') {
      next();
    } else if (e.key === 'ArrowLeft') {
      prev();
    } else if (e.key === 'Tab') {
      // Keep keyboard focus inside the viewer while it's open.
      var focusable = [closeBtn, prevBtn, nextBtn].filter(function (b) {
        return !b.hidden;
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      if (!lightbox.contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function open(i, opener) {
    lastFocus = opener || null;
    lightbox.hidden = false;
    document.documentElement.classList.add('article-album-lightbox-open');
    show(i);
    closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    lightbox.hidden = true;
    document.documentElement.classList.remove('article-album-lightbox-open');
    document.removeEventListener('keydown', onKeydown);
    bigImg.removeAttribute('src');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  links.forEach(function (link, i) {
    link.addEventListener('click', function (e) {
      // Let ctrl/cmd/shift/middle-click open the image normally.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      open(i, link);
    });
  });

  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', prev);
  nextBtn.addEventListener('click', next);
  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox || e.target === backdrop) close();
  });

  // Swipe left/right on touch screens.
  var touchX = 0;
  var touchY = 0;
  lightbox.addEventListener(
    'touchstart',
    function (e) {
      touchX = e.changedTouches[0].clientX;
      touchY = e.changedTouches[0].clientY;
    },
    { passive: true }
  );
  lightbox.addEventListener(
    'touchend',
    function (e) {
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) next();
        else prev();
      }
    },
    { passive: true }
  );
})();
